<template>
  <div class="slider_icons margin-general">
    <div class="why-choose-title-container">
      <h2>{{ $t(title) }}</h2>
    </div>
    <div class="why-choose-subTitle-container">
      <p class="subTitle body-4">{{ $t(description) }}</p>
      <div v-if="descript_extra">
        <p class="subTitle body-4 extra">{{ $t(extra) }}</p>
      </div>
    </div>

    <div class="cards-static-container">
      <div v-for="item in cards" :key="item.title" class="static-card">
        <div class="icon-box">
          <span class="material-symbols-outlined icon" translate="no">
            {{ item.icon }}
          </span>
        </div>
        <div class="card-text-wrapper">
          <p class="title bold">{{ $t(item.title) }}</p>
          <a
            v-if="item.url"
            class="find-more link-4"
            :href="localPath(item.url)"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t(item.link) }}
          </a>
        </div>
      </div>
    </div>

    <div v-if="buttonText" class="buttons-container">
      <button class="primary-button-medium" @click="handleButtonClick">
        {{ $t(buttonText) }}
      </button>
    </div>
  </div>
</template>

<script setup>
const localPath = useLocalePath();

const props = defineProps({
  title: String,
  description: String,
  descript_extra: Boolean,
  extra: String,
  cards: Array,
  buttonText: String,
  buttonTo: [String, Function],
});

const handleButtonClick = () => {
  if (typeof props.buttonTo === 'string') {
    window.open(props.buttonTo, '_blank');
  } else if (typeof props.buttonTo === 'function') {
    props.buttonTo();
  }
};
</script>